"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorMessage;
var _react = _interopRequireDefault(require("react"));
var _useTranslation = _interopRequireDefault(require("../../../hooks/useTranslation"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ErrorIcon = _interopRequireDefault(require("../ErrorIcon"));
var _templateObject; // @ts-ignore: Unreachable code error
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var FlexBox = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  justify-content: ", ";\n  align-items: ", ";\n"])), function (props) {
  return props.justify;
}, function (props) {
  return props.align;
});
function ErrorMessage() {
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 2
    }
  }, /*#__PURE__*/_react.default.createElement(FlexBox, {
    justify: 'flex-start',
    align: 'center'
  }, /*#__PURE__*/_react.default.createElement(_ErrorIcon.default, null), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    appearance: "secondary"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "barring-management-toggle-error-message"
  }, t('errorText')))));
}